'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TokensManager = function () {
  function TokensManager(options) {
    (0, _classCallCheck3.default)(this, TokensManager);
    this.options = {};
    var accessTokenName = options.accessTokenName,
        refreshTokenName = options.refreshTokenName,
        secureCookies = options.secureCookies,
        cookiesDomain = options.cookiesDomain,
        rememberPeriod = options.rememberPeriod;


    this.options = {
      accessTokenName: accessTokenName,
      refreshTokenName: refreshTokenName,
      secureCookies: secureCookies,
      cookiesDomain: cookiesDomain,
      rememberPeriod: rememberPeriod
    };
  }

  (0, _createClass3.default)(TokensManager, [{
    key: 'getAccessToken',
    value: function getAccessToken() {
      return _jsCookie2.default.get(this.options.accessTokenName);
    }
  }, {
    key: 'getRefreshToken',
    value: function getRefreshToken() {
      return _jsCookie2.default.get(this.options.refreshTokenName);
    }
  }, {
    key: 'saveAccessToken',
    value: function saveAccessToken(token) {
      _jsCookie2.default.set(this.options.accessTokenName, token, {
        secure: this.options.secureCookies,
        domain: this.options.cookiesDomain
      });
    }
  }, {
    key: 'saveRefreshToken',
    value: function saveRefreshToken(token) {
      var remember = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var options = {
        secure: this.options.secureCookies,
        domain: this.options.cookiesDomain
      };

      if (remember) {
        options.expires = this.options.rememberPeriod;
      }

      _jsCookie2.default.set(this.options.refreshTokenName, token, options);
    }
  }, {
    key: 'saveTokens',
    value: function saveTokens(_ref) {
      var accessToken = _ref.accessToken,
          refreshToken = _ref.refreshToken;

      this.saveAccessToken(accessToken);
      this.saveRefreshToken(refreshToken);
    }
  }, {
    key: 'removeTokens',
    value: function removeTokens() {
      _jsCookie2.default.remove(this.options.accessTokenName, {
        secure: this.options.secureCookies,
        domain: this.options.cookiesDomain
      });
      _jsCookie2.default.remove(this.options.refreshTokenName, {
        secure: this.options.secureCookies,
        domain: this.options.cookiesDomain
      });
    }
  }]);
  return TokensManager;
}();

exports.default = TokensManager;
//# sourceMappingURL=tokens-manager.js.map